module.exports = __webpack_public_path__ + "static/media/brego3536.5bfd79ec.jpg";